<template>
  <div class="home">
    <!-- 轮播 -->
    <div class="lunbo" v-if="$route.meta.banner">
      <a-carousel dotsClass="dot" autoplay>
        <div v-for="(item, i) in banner" :key="i">
          <a :href="item.link"><img :src="'http://' + item.image_file"></a>
        </div>
      </a-carousel>
    </div>
    <!-- 产品中心 -->
    <div class="product">
      <div class="title main-font30 text-center primary_color">
        {{ $t('title.productCenter') }}<div class="unline"></div>
        <h6 class="main-font20 text-center color585 mar_t5">PRODUCTCENTER</h6>
        <div class="flex_je main-center">
          <span class="main-font16 more" @click="changeActive(1, '/product')">
            {{ $t('title.more') }}
            <a-icon type="right" />
          </span>
        </div>
      </div>
      <!-- 切换轮播 -->
      <div class="recommendPage main-center">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, i) in product" :key="i">
            <router-link :to="{ path: '/pDetails', query: { uuid: item.uuid } }">
              <div class="item-box">
                <div class="img-box">
                  <img :src="'http://' + item.image_head_file" v-if="$store.state.langStates == 'zh'">
                  <img :src="'http://' + item.image_head_file_en" v-if="$store.state.langStates == 'en'">
                </div>
                <div class="text" v-if="$store.state.langStates == 'zh'">{{ item.category }} {{ item.series }}-{{
                  item.name }}
                </div>
                <div class="text" v-if="$store.state.langStates == 'en'">{{ item.category_en }}
                  {{ item.series_en }}-{{ item.name_en }}</div>
              </div>
            </router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev">
          <img src="../assets/img/left.png">
        </div>
        <div class="swiper-button-next" slot="button-next">
          <img src="../assets/img/right.png">
        </div>
      </div>
    </div>
    <!-- 应用视频 -->
    <div class="video main-center" v-if="video.length > 0">
      <div class="title main-font30 text-center primary_color">
        {{ $t('title.applicationVideo') }}<div class="unline"></div>
        <h6 class="main-font20 text-center color585 mar_t5">APPLICATION NIDEO</h6>
        <div class="flex_je main-center">
          <span class="main-font16 more cp" @click="changeActive(2, '/video')">
            {{ $t('title.more') }}
            <a-icon type="right" />
          </span>
        </div>
      </div>
      <div class="info" v-for="(item, i) in video" :key="i" @click="showModal(i)" v-show="i < 3">
        <div class="video_info">
          <img :src="'http://' + item.head_image_file" v-if="$store.state.langStates == 'zh'">
          <img :src="'http://' + item.head_image_file_en" v-if="$store.state.langStates == 'en'">
          <div class="play">
            <a-icon type="play-circle" style="color: #fff;font-size: 50px;" />
          </div>
        </div>
      </div>
    </div>
    <!-- 下载中心 -->
    <div class="download">
      <!-- <div class="title main-font30 main-center" style="color:#fff;">{{$t('title.downloadCenter')}}</div> -->
      <div class="title main-font30 text-center primary_color" style="color:#fff;padding-top:30px;">
        {{ $t('title.downloadCenter') }}<div class="unline" style="background:#fff;"></div>
        <h6 class="main-font20 text-center color585 mar_t5" style="color:#fff;">DOWNLOAD CENTER</h6>
        <div class="flex_je main-center">
          <span class="main-font16 more cp" @click="changeActive(2, '/video')">
            {{ $t('title.more') }}
            <a-icon type="right" />
          </span>
        </div>
      </div>
      <div class="btn flex_ cp" @click="changeActive(5, '/download')">
        <img src="../assets/img/downLoad-fill.png" style="width:27px;height:27px;margin-right:8px">
        <!-- <router-link to="/download"><a-button type="primary" block>{{$t('content.index_down')}}</a-button></router-link> -->
        <div>{{ $t('content.index_down') }}</div>
      </div>
    </div>
    <!-- 弹窗 -->
    <!-- 视频弹窗 -->
    <a-modal v-model="visible" :closable="true" :footer="null" width="80%" :destroyOnClose="true"
      wrapClassName="viderBox">
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
        :options="playerOptions"></video-player>
    </a-modal>
  </div>
</template>

<script>
import {
  swiper,
  swiperSlide
} from "vue-awesome-swiper";
import "vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css";
import { mapMutations } from 'vuex'
export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'BusImg',
  data() {
    return {
      banner: '',
      product: '',
      video: '',
      swiperOption: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 40,
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      visible: false,
      // 视频播放
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "",
          src: '' //url地址
        }],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.init(this.$store.state.langStates)
  },
  methods: {
    ...mapMutations(['changeA']),
    changeActive(v, url) {
      console.log(v, '---ld');
      this.$router.push(url)
      this.changeA(v)
    },
    showModal(i) {
      this.visible = true;
      this.playerOptions.autoplay = true
      if (this.$store.state.langStates == 'zh') {
        let file = this.video[i].video_file
        if (file.indexOf("http") == -1) {
          this.playerOptions.sources[0].src = 'http://' + this.video[i].video_file
        } else {
          this.playerOptions.sources[0].src = this.video[i].video_file
        }
      } else if (this.$store.state.langStates == 'en') {
        let file = this.video[i].video_file_en
        if (file.indexOf("http") == -1) {
          this.playerOptions.sources[0].src = 'http://' + this.video[i].video_file_en
        } else {
          this.playerOptions.sources[0].src = this.video[i].video_file_en
        }
      }
    },
    init(lang) {
      // 获取首页的客服、banner、产品、视频等数据列表
      this.$api.dongjuapi.index(lang, {
        lang
      }).then(res => {
        this.product = res.data.data.product
        this.video = res.data.data.video
      }).catch(err => {

      })
      // 获取banner
      this.$api.dongjuapi.banner({
        type: 'index'
      }).then(res => {
        if (res.data.code == 200) {
          this.banner = res.data.data
        }
      })
    }
  },
  watch: {
    "$route": {
      handler(route) {
        const that = this
        if (route.name === '/') {
          that.init(that.$store.state.langStates)
        }
      }
    },
    '$store.state.langStates': function (val) {
      this.init(val)
    }
  }
}
</script>
<style lang="less">
.viderBox {
  .ant-modal-close-x {
    width: 100px;
    height: 100px;
    line-height: 100px;
    font-size: 35px;
    color: #fff !important;
  }
}

.home {
  .more {
    color: #888585;

    a {
      color: #888585;
    }
  }

  .product {
    width: 100%;
    height: 700px;
    background: #fff;

    .title {
      padding-top: 80px;
      padding-bottom: 50px;
    }

    .recommendPage {
      position: relative;
      width: 88.75%;

      .swiper-container {
        position: relative;
        width: 90%;
        height: auto;

        .swiper-slide {
          // width: 100%;
          height: 389px;
          // background: #eee;
          font-size: 16px;
          text-align: center;
          background-color: #F7F5F5;

          .item-box {
            display: flex;
            height: 100%;
            flex-direction: column;
          }

          .img-box {
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 90%;
              // height: 100%;
              object-fit: cover;
              margin: 10px;
            }
          }


          .text {
            // width: 100%;
            padding: 8px 0;
            color: rgba(75, 72, 72, 1);
            font-size: 16px;
            background-color: #fff;
            min-height: 64px;
            margin: 10px;
            padding: 10px 6px;
          }
        }
      }

      .swiper-button-prev {
        width: 36px;
        height: 36px;
        background: url("../assets/img/left.png") 100% 100%;
        outline: none;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .swiper-button-next {
        width: 36px;
        height: 36px;
        background: url(../assets/img/right.png) 100% 100%;
        outline: none;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .video {
    height: 450px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .title {
      width: 100%;
      padding-top: 60px;
    }

    .info {
      width: 400px;
      height: 225px;
      background: #fff;
      border-radius: 2px;
      float: left;

      &:nth-child(3n+3) {
        margin-right: 0;
      }

      .video_info {
        width: 100%;
        height: 225px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          border-radius: 2px;
        }

        .play {
          position: absolute;
          width: 50px;
          height: 50px;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }

  .about {
    width: 100%;
    height: auto;
    background: #fff;
    padding-bottom: 80px;

    .title {
      padding-top: 80px;
      padding-bottom: 36px;
    }

    .info {
      >p {
        line-height: 1.8;
      }

      .i-info {
        padding-top: 35px;
        display: flex;
        justify-content: space-around;
      }
    }
  }

 

  .download {
    height: 522px;
    width: 100%;
    background: url(../assets/img/download.png) no-repeat;
    position: relative;
    background-size: 100% auto;

    .title {
      padding-top: 80px;
      // margin-left: 160px;
    }

    .btn {
      width: 200px;
      height: 50px;
      color: rgba(31, 94, 165, 1);
      font-size: 23px;
      background-color: #fff;
      position: absolute;
      top: 200px;
      left: 333px;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.23);

      .ant-btn {
        height: 50px;
      }
    }
  }
   /* 当屏幕宽度小于1380px时 */
  @media (max-width: 1400px) {
    .download {
      height: 450px;
    }
  }
   @media (max-width: 1350px) {
    .download {
      height: 430px;
    }
  }
   @media (max-width: 1300px) {
    .download {
      height: 410px;
    }
  }
}
</style>
